import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import toast, { Toaster } from 'react-hot-toast';
import { fetchDeliveryTypes, addDeliveryType, updateDeliveryType, deleteDeliveryType } from '../../apis/home/deliveryTypes';

export default function DeliveryPrice() {

    const [deliveryTypes, setDeliveryTypes] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [newDelivery, setNewDelivery] = useState({ type: '', time: '', price: '' });
    const [loading, setLoading] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [editDelivery, seteditDelivery] = useState(null);

    const openDialog = () => setDialogVisible(true);
    const hideDialog = () => {
        setDialogVisible(false);
        setisEdit(false);
    };

    const typehandleKeyPress = (e) => {
        const regex = /^[a-zA-Z]$/;
        if (!regex.test(e.key)) {
            e.preventDefault();
        }
    };

    // const timehandleKeyPress = (e) => {
    //     const regex = /^[a-zA-Z0-9]$/;
    //     if (!regex.test(e.key)) {
    //         e.preventDefault();
    //     }
    // };

    const getDeliveryTypes = async () => {

        try {
            setLoading(true);
            const types = await fetchDeliveryTypes();
            setDeliveryTypes(types);
        } catch (error) {
            toast.error('Error: Fetching Delivery Type');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getDeliveryTypes();
    }, []);

    // function validatePromoCode(code) {
    //     const regex = /^[A-Za-z0-9]+$/;
    //     return regex.test(code);
    // }

    const saveDeliveryType = async () => {
        try {
            setLoading(true);
            if (isEdit) {
                if (!editDelivery.type || !editDelivery.time || !editDelivery.price) {
                    toast.error('Please provide all type, time & price!');
                    return;
                }

                // if (!validatePromoCode(editDelivery.type)) {
                //     toast.error("Promo type must be alphanumeric only.");
                //     return;
                // }

                // await updateDeliveryType(editDelivery);
                const updatedDelivery = await updateDeliveryType(editDelivery);

                console.log(updatedDelivery);

                toast.success('Delivery Type Updated');

                const index = deliveryTypes.findIndex(user => user.deliveryTypeId === editDelivery.deliveryTypeId);
                if (index !== -1) {
                    deliveryTypes[index].type = editDelivery.type;
                    deliveryTypes[index].time = editDelivery.time;
                    deliveryTypes[index].price = editDelivery.price;
                }

            } else {

                if (!newDelivery.type || !newDelivery.time || !newDelivery.price) {
                    toast.error('Please provide all type, time & price!');
                    return;
                }

                const addedDelivery = await addDeliveryType(newDelivery);
                newDelivery.deliveryTypeId = addedDelivery.id;
                deliveryTypes.push(newDelivery);

                toast.success('Delivery type Added');
            }

            setNewDelivery({ type: '', time: '', price: '' });
            hideDialog();
        } catch (error) {
            console.log(error);

            toast.error(!isEdit ? 'Error: Adding Delivery Type' : 'Error: Editing Delivery Type');
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (item) => {
        console.log(item);

        setisEdit(true);
        setDialogVisible(true);
        seteditDelivery(item);
    };

    const handleDelete = async (item) => {
        try {
            await deleteDeliveryType(item.deliveryTypeId);
            toast.success('Delivery Type Deleted');
            setDeliveryTypes(prev => prev.filter(b => b.deliveryTypeId !== item.deliveryTypeId));
        } catch (error) {
            toast.error('Error: Deleting Delivery Type');
        } finally {
            setLoading(false);
        }
    };

    const actionTemplate = (rowData) => (
        <div className="p-d-flex p-ai-center gap-2">
            <Button
                icon="pi pi-pencil"
                className="p-button-text"
                tooltip="Edit Delivery Type"
                onClick={() => handleEdit(rowData)}
            />
            <Button
                icon="pi pi-trash"
                className="p-button-text p-button-danger"
                tooltip="Delete Delivery Type"
                onClick={() => handleDelete(rowData)}
            />
        </div>
    );

    return (
        <>
            <Toaster />
            <h2>Delivery Types</h2>

            <Button label="Add Delivery Type" icon="pi pi-plus" onClick={openDialog} />

            <Dialog header={isEdit ? 'Edit Delivery Type' : 'Add Delivery Type'} visible={dialogVisible} onHide={hideDialog}>
                <div className="flex flex-col gap-3">

                    {
                        isEdit ?
                            <>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Type</label>
                                    <InputText placeholder="e.g - Express | Standard" value={editDelivery.type} onKeyPress={typehandleKeyPress} onChange={(e) => seteditDelivery({ ...editDelivery, type: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Time</label>
                                    <InputText placeholder="e.g - 1 to 2 hrs" value={editDelivery.time} onChange={(e) => seteditDelivery({ ...editDelivery, time: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Price - ₹</label>
                                    <InputText placeholder="e.g - 100" keyfilter="int" value={editDelivery.price} onChange={(e) => seteditDelivery({ ...editDelivery, price: e.target.value })} />
                                </div>
                            </>
                            :
                            <>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Type</label>
                                    <InputText placeholder="e.g - Express | Standard" maxLength={12} onKeyPress={typehandleKeyPress} onChange={(e) => setNewDelivery({ ...newDelivery, type: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Time</label>
                                    <InputText placeholder="e.g - 1 to 2 hrs" onChange={(e) => setNewDelivery({ ...newDelivery, time: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Delivery Price - ₹</label>
                                    <InputText placeholder="e.g - 100" keyfilter="int" onChange={(e) => setNewDelivery({ ...newDelivery, price: e.target.value })} />
                                </div>
                            </>
                    }
                    <div style={{ paddingTop: '2rem' }}>
                        <Button loading={loading} label="Save" icon="pi pi-check" onClick={saveDeliveryType} />
                    </div>
                </div>
            </Dialog>

            <div className="p-m-3 mt-4">
                <DataTable value={deliveryTypes} loading={loading} emptyMessage='No Delivery Types Found'>
                    <Column field="type" header="Delivery Type" />
                    <Column field="time" header="Delivery Time" />
                    <Column field="price" header="Delivery Price" />
                    <Column header="Actions" body={actionTemplate} />
                </DataTable>
            </div>
        </>
    );
}